import React from "react";
import { IPlaylist } from "../../../Api/Interface/api.interface";
import ScheduleTab from "./ScheduleTab";
import MenuRulesTab from "./MenuRulesTab";
import PosSyncTab from "./PosSyncTab";
import ScreenAssignmentTab from "./ScreenAssignmentTab";
import HistoryTab from "./HistoryTab";

export interface MenuTabProps {
  playlistId: number;
  playlist?: IPlaylist;
  groupId: number | null;
  companyId: number | null;
}

/** Dispatches the non-Content editor tabs (see index.tsx tab order). */
const MenuTabs: React.FC<{ tab: number } & MenuTabProps> = ({ tab, ...rest }) => {
  switch (tab) {
    case 1: return <ScheduleTab {...rest} />;
    case 2: return <MenuRulesTab {...rest} />;
    case 3: return <PosSyncTab {...rest} />;
    case 4: return <ScreenAssignmentTab {...rest} />;
    case 5: return <HistoryTab {...rest} />;
    default: return null;
  }
};

export default MenuTabs;
